import { Link } from './link.model';

export const PATHS = {
  signIn: () => new Link('/sign-in', 'Repository Documentale'),
  listTranscriptions: () =>
    new Link('/folders/:folderId', 'Repository Documentale'),
  defaultPage: () => new Link('/default-page', 'Repository Documentale'),
};
